jQuery(document).ready(function ($) {
  if ($(window).width() > 767) {
    $('.nice-select').niceSelect();
  }

  /* MENU DESKTOP */
  $('.menuWrap').show();

  if(Math.abs(document.body.getBoundingClientRect().top) > 40){
    $('.desktopMenuWrap.mainLevel').css('top', $('nav').height());
    $('.overlay-fullscreen').css('top', $('nav').height());
  }else{
    $('.desktopMenuWrap.mainLevel').css('top', $('nav').height() + $('.announcement-bar-section').height());
    $('.overlay-fullscreen').css('top', $('nav').height() + $('.announcement-bar-section').height());
  }

  function adjustMenuHeight(){
    if(window.scrollY == 0){
      $('.desktopMenuWrap.mainLevel').css('top', $('nav').height() + $('.announcement-bar-section').height());
      $('.overlay-fullscreen').css('top', $('nav').height() + $('.announcement-bar-section').height());
    }
    if(window.scrollY > 0 && window.scrollY < $('.announcement-bar-section').height()){
      $('.desktopMenuWrap.mainLevel').css('top', $('nav').height() + ($('.announcement-bar-section').height() - window.scrollY));
      $('.overlay-fullscreen').css('top', $('nav').height() + ($('.announcement-bar-section').height() - window.scrollY));
    }else if(window.scrollY > $('.announcement-bar-section').height()){
      $('.desktopMenuWrap.mainLevel').css('top', $('nav').height());
      $('.overlay-fullscreen').css('top', $('nav').height());
    }
  }

  $('nav .nav-link.hasSubMenu').on('click', function (e) {
    e.preventDefault();
    $('.desktopMenuWrap.mainLevel').each(function () {
      if ($(this).hasClass('show')) {
        $(this).removeClass('show');
      }
    });

    $('.desktopMenuWrap.thirdLevel').each(function () {
      if ($(this).hasClass('show')) {
        $(this).removeClass('show');
      }
    });

    $(this).next('.desktopMenuWrap.mainLevel').toggleClass('show');
    adjustMenuHeight();
    window.addEventListener("scroll", adjustMenuHeight)
    $('.overlay-fullscreen').addClass('show');

    document.querySelectorAll(".boxLink").forEach((el) => {
      $(el).fadeOut();
    });
    // $('.desktopMenuWrap.mainLevel .boxLink').fadeOut();
    $('.nav-link.hasThirdLevel').removeClass('active');
    $('body').addClass('overflow-hidden');
  });

  $('.overlay-fullscreen').on('click', function () {
    $('.desktopMenuWrap').removeClass('show');
    $('.mobileMenuWrap').removeClass('show');
    $('.desktopMenuWrap .nav-link').removeClass('active');
    document.querySelectorAll(".boxLink").forEach((el) => {
      $(el).fadeOut();
    });
    // $('.desktopMenuWrap.mainLevel .boxLink').fadeOut();
    $('.overlay-fullscreen').removeClass('show');
    $('.mobileMenuWrap.thirdLevel .boxLink').fadeOut();
    $('body').removeClass('overflow-hidden');
  });

  $('.desktopMenuWrap .close').on('click', function () {
    $('.desktopMenuWrap').removeClass('show');
    $('.desktopMenuWrap .nav-link').removeClass('active');
    document.querySelectorAll(".boxLink").forEach((el) => {
      $(el).fadeOut();
    });
    // $('.desktopMenuWrap.mainLevel .boxLink').fadeOut();
    $('.overlay-fullscreen').removeClass('show');
    $('body').removeClass('overflow-hidden');
  });

  $('.nav-link.hasThirdLevel').on('click', function (e) {
    e.preventDefault();
    $('.desktopMenuWrap.thirdLevel').removeClass('show');
    $('.nav-link').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.overflow-scroll-intermediate-section').css('min-height', `calc(100vh - ${$('nav').height() + $('.announcement-bar-section').height() + 20}px`);
    $(this).closest('.overflow-scroll-intermediate-section').css('max-height', `calc(100vh - ${$('nav').height() + $('.announcement-bar-section').height() + 20}px`);

    document.querySelectorAll(".boxLink").forEach((el) => {
      $(el).fadeOut();
    });
    document.querySelectorAll(".boxLink").forEach((el) => {
      if($(this)[0].textContent === el.dataset.level){
        $(el).fadeToggle();
      }
    });

    $(this).next().toggleClass('show');
  });

  /* MENU MOBILE */
  $('#toggleMobileMenu').on('click', function (e) {
    e.preventDefault();
    $('.section-header').css('z-index', 60);
    document.querySelector('.switch-lang-menu-mobile').style.display = 'none';
    if ($('.mobileMenuWrap.mainLevel').hasClass('show')) {
      $('.mobileMenuWrap').removeClass('show');
      $('.overlay-fullscreen').removeClass('show');
      $('body').removeClass('overflow-hidden');
    } else {
      $('.mobileMenuWrap.mainLevel').toggleClass('show');
      $('.overlay-fullscreen').addClass('show');
      $('body').addClass('overflow-hidden');
    }
  });

  $('.mobileMenuWrap.mainLevel .nav-link.hasSubLevel').on('click', function () {
    $(this).next('.mobileMenuWrap.secondLevel').toggleClass('show');
  });

  $('.mobileMenuWrap.secondLevel .nav-link.hasSubLevel').on('click', function () {
    $(this).next('.mobileMenuWrap.thirdLevel').toggleClass('show');
    document.querySelectorAll(".boxLinkMobile").forEach((el) => {
      $(el).fadeOut();
    });

    document.querySelectorAll(".boxLinkMobile").forEach((el) => {
      if($(this)[0].textContent === el.dataset.level){
        $(el).fadeToggle();
      }
    });
  });

  $('.mobileMenuWrap .close').on('click', function () {
    $('.mobileMenuWrap').removeClass('show');
    document.querySelectorAll(".boxLinkMobile").forEach((el) => {
      $(el).fadeOut();
    });
    // $(this).closest('.mobileMenuWrap.thirdLevel').children('.boxLinkMobile').fadeOut();
    $('.overlay-fullscreen').removeClass('show');
    $('body').removeClass('overflow-hidden');
  });

  $('.mobileMenuWrap .back').on('click', function () {
    $(this).closest('.mobileMenuWrap').removeClass('show');
    $(this).closest('.mobileMenuWrap.thirdLevel').children('.boxLinkMobile').fadeOut();
  });

  /* CATEGORIA */
  swiperCategorie = new Swiper('.swiperCategorie', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesOffsetAfter: 32,
    slidesOffsetBefore: 32,
    slidesPerView: 'auto',
    centeredSlides: false,
    centerInsufficientSlides: true,
    spaceBetween: 20,
    freeMode: true,
    watchOverflow: true,
  });

  window.swiperCategorie = swiperCategorie;

  swiperBlogFooter = new Swiper('.swiperBlogFooter', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 1.2,
    slidesOffsetAfter: 15,
    slidesOffsetBefore: 15,
    centeredSlides: false,
    centerInsufficientSlides: true,
    spaceBetween: 15,
    // freeMode: true,
    watchOverflow: true,
    breakpoints: {
      728: {
        slidesPerView: 2.2,
      },
    },
  });

  /* SCHEDA PRODOTTO */

  $('.showFullProductDescription').on('click', function () {
    $('.productDescription').toggleClass('full');
    $(this).children('.hide').toggle();
    $(this).children('.showAll').toggle();
  });


  var lastScrollTop = 0;
  jQuery(window).on('scroll', function () {
    if ($(window).width() < '768') {
      var $DivExist = $('.product_addToCartBtn_mobile');
      if ($DivExist.length) {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
          $('.product_addToCartBtn_mobile').slideDown();
        } else if (st < lastScrollTop) {
          $('.product_addToCartBtn_mobile').slideUp();
        }
        lastScrollTop = st <= 0 ? 0 : st;
      }
    }
  });

  $('.guidaTaglieBtn').on('click', function () {
    $('.guidaTaglieBtn').removeClass('active');
    $(this).addClass('active');

    if ($(this).data('type') == 'uk') {
      $('input[name="taglia"]').parents().find('label[data-type="uk"]').show();
      $('input[name="taglia"]').parents().find('label[data-type="eu"]').hide();
      $('input[name="taglia"]').parents().find('label[data-type="us"]').hide();
    } else if ($(this).data('type') == 'us') {
      $('input[name="taglia"]').parents().find('label[data-type="us"]').show();
      $('input[name="taglia"]').parents().find('label[data-type="uk"]').hide();
      $('input[name="taglia"]').parents().find('label[data-type="eu"]').hide();
    } else {
      $('input[name="taglia"]').parents().find('label[data-type="eu"]').show();
      $('input[name="taglia"]').parents().find('label[data-type="uk"]').hide();
      $('input[name="taglia"]').parents().find('label[data-type="us"]').hide();
    }
  });

  if ($('.m-left').length) {
    $position = $('.m-left').offset();
    $p_left = $position.left + 24;
  } else {
    $p_left = 0;
  }

  swiperProducts = new Swiper('.swiperProducts', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 1.5,
    slidesOffsetAfter: 20,
    slidesOffsetBefore: $p_left,
    centeredSlides: false,
    centerInsufficientSlides: true,
    spaceBetween: 15,
    freeMode: true,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2.3,
      },
      1024: {
        slidesPerView: 3.3,
      },
      1280: {
        slidesPerView: 3.8,
      },
      1536: {
        slidesPerView: 4.5,
      },
    },
  });

  $('window').on('resize', function () {
    if ($('.m-left').length) {
      $position = $('.m-left').offset();
      $p_left = $position.left + 24;
      swiperProducts.params.slidesOffsetBefore = $p_left;
    }
  });

  swiperProductImagesFishing = new Swiper('.swiperProductImagesFishing', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 1,
    centeredSlides: false,
    centerInsufficientSlides: true,
    spaceBetween: 0,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  window.swiperProductImagesFishing = swiperProductImagesFishing;
  swiperProductImages = new Swiper('.swiperProductImages', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 1,
    centeredSlides: false,
    centerInsufficientSlides: true,
    spaceBetween: 0,
    watchOverflow: true
  });
  window.swiperProductImages = swiperProductImages;

  swiperVariantiColore = new Swiper('.swiperVariantiColore', {
    lazy: {
      loadPrevNext: true,
    },
    watchSlidesProgress: true,
    direction: 'horizontal',
    centerInsufficientSlides: false,
    spaceBetween: 12,
    freeMode: false,
    watchOverflow: false,
    slidesPerView: 'auto',
    loop: false,
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });



  // swiperVariantiColoreModal = new Swiper('.swiperVariantiColoreModal', {
  //   lazy: {
  //     loadPrevNext: true,
  //   },
  //   watchSlidesProgress: true,
  //   direction: 'horizontal',
  //   centerInsufficientSlides: false,
  //   spaceBetween: 12,
  //   freeMode: false,
  //   watchOverflow: false,
  //   slidesPerView: 'auto',
  //   loop: false,
  //   centeredSlides: false
  // });

  swiperBreadcrumb = new Swiper('.swiperBreadcrumb', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 'auto',
    slidesOffsetAfter: 24,
    slidesOffsetBefore: 24,
    centeredSlides: false,
    centerInsufficientSlides: false,
    spaceBetween: 10,
    freeMode: true,
    watchOverflow: true,
  });

  swiperQuickLinks = new Swiper('.swiperQuickLinks', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 'auto',
    slidesOffsetAfter: 24,
    slidesOffsetBefore: 24,
    centeredSlides: false,
    centerInsufficientSlides: false,
    spaceBetween: 10,
    freeMode: true,
    watchOverflow: true,
  });

  /* FOOTER */

  $('.showAllStores').on('click', function () {
    $('.storeList.allStores').slideDown();
    $(this).hide();
  });

  swiperFooterMenu = new Swiper('.swiperFooterMenu', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 'auto',
    slidesOffsetAfter: 10,
    slidesOffsetBefore: 10,
    centeredSlides: false,
    centerInsufficientSlides: true,
    spaceBetween: 8,
    freeMode: true,
    watchOverflow: true,
  });

  swiperQuickLink = new Swiper('.swiperQuickLink', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesPerView: 'auto',
    slidesOffsetAfter: 10,
    slidesOffsetBefore: 10,
    centeredSlides: false,
    centerInsufficientSlides: true,
    spaceBetween: 15,
    freeMode: true,
    watchOverflow: true,
  });

  swiperBannerHome_3 = new Swiper('.swiperBannerHome_3', {
    loop: false,
    lazy: {
      loadPrevNext: true,
    },
    direction: 'horizontal',
    slidesOffsetAfter: 0,
    slidesOffsetBefore: 0,
    slidesPerView: 1.3,
    centeredSlides: false,
    centerInsufficientSlides: false,
    spaceBetween: 8,
    freeMode: true,
    watchOverflow: true,
    breakpoints: {
      992: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 2.3,
      },
      1300: {
        slidesPerView: 3,
      },
      1536: {
        slidesPerView: 3,
      },
    },
  });
});
